module.exports = __webpack_public_path__ + "static/media/x-black.d5684a40.svg";